import { Link } from "react-router-dom";
import { logoSrc } from "../utils/brand";

// Height in pixels for each "size" preset. Width auto-scales by image aspect ratio.
const SIZES = { sm: 28, md: 70, lg: 88 };

export default function BrandLogo({
  size = "md",
  showText = true,
  subtitle,
  to,
  className = "",
  collapsed = false,
  inverted = false,
}) {
  const px = typeof size === "number" ? size : SIZES[size] ?? SIZES.md;
  const imgW = px * 2; // generous intrinsic width so browsers render crisply

  const inner = (
    <>
      <img
        src={logoSrc}
        alt="FullCirkl logo"
        className="shrink-0 object-contain"
        style={{
          height: `${px}px`,
          width: "auto",
        }}
        width={imgW}
        height={px}
        loading="eager"
        draggable={false}
        onError={(e) => {
          // graceful fallback: hide broken image so the text label still aligns cleanly
          e.currentTarget.style.opacity = "0";
        }}
      />
      {showText && !collapsed && (
        <div className="flex min-w-0 flex-col leading-tight">
          <span
            className={`truncate text-sm font-extrabold tracking-tight sm:text-[15px] transition-colors ${inverted ? "text-white" : "text-slate-900 dark:text-white"
              }`}
          >
            FullCirkl
          </span>
          {subtitle && (
            <span className="truncate text-[9px] font-bold uppercase tracking-[0.14em] text-[#D4A45A] sm:text-[10px]">
              {subtitle}
            </span>
          )}
        </div>
      )}
    </>
  );

  const wrap = `flex min-w-0 items-center gap-2.5 ${className}`;

  if (to) {
    return (
      <Link to={to} className={`${wrap} no-underline`}>
        {inner}
      </Link>
    );
  }

  return <div className={wrap}>{inner}</div>;
}
